// Licznik „Pozostała liczba zwrotów na dziś".
//
// O tym, czy formularz w ogóle się pokazuje, decyduje SERWER (IndexController + stageProvider):
// przy before/after lub wyczerpanej puli formularza nie ma wcale. Ten skrypt tylko odświeża
// wyświetlaną liczbę (bez blokowania — mid-fill wyczerpanie obsługuje modal poolEmpty przy WYŚLIJ).
function initRefundCounter() {
    const el = document.querySelector('[data-refund-counter]');
    if (!el) return;

    const url = el.dataset.counterUrl;
    const valueEl = el.querySelector('[data-refund-value]');
    if (!url || !valueEl) return;

    fetch(url, { credentials: 'same-origin' })
        .then(res => res.ok ? res.json() : Promise.reject())
        .then(data => {
            const available = Number(data.available ?? 0);
            valueEl.textContent = available;
        })
        .catch(() => { /* brak odświeżenia — zostaje liczba wyrenderowana przez serwer */ });
}

initRefundCounter();
